import React, {useContext, useEffect} from "react"

// context, data & util
import {ShopContext} from "../../../context/ShopContext"
import {CatalogueContext} from "../../../context/CatalogueContext"
import Data from "../../../data" // TODO should we not use ShopContext instead?
import Util from "../../../util"
import Config from "../../../config"

// components
import {Form} from "../../controls"
import {Scaffolding} from "../../shared"
import Checkout from "./Checkout"

// styling
import "./Personalize.scss"

// form fields
const fields = Config.personalizeFields

// the component
function Personalize() {
  // context
  const shop = useContext(ShopContext)
  const catalogue = useContext(CatalogueContext)

  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])

  // shop not yet loaded its data?
  if(!catalogue.isReady) {
    return null
  }

  const onFormUpdate = (e) => {
    Data.Cart.setPersonlization(e.entity)
    validate()
  }

  const validate = () => {
    let validation = Data.Cart.getValidation()
    shop.cart.setValidation(validation)
  }

  // render
  // if this is the first time the user arrives here, we don't want to display field validation messages
  const hideFieldValidation = Data.Storage.getCheckoutProgress() <= 2
  const formEntity = Data.Cart.getPersonalization()
  return (
    <Scaffolding>
      <Checkout stepName="personalize" title="Personalisieren">
        <div id="v-personalize">
          <div id="v-personalize-form">
            <Form 
              fields={fields} 
              entity={formEntity} 
              onUpdate={onFormUpdate} 
              hideFieldValidation={hideFieldValidation}
            />
          </div>
        </div>
      </Checkout>
    </Scaffolding>
  )
}

export default Personalize